<template>
  <div class="container">
    <div class="page">
      <div class="header_nav">
        <div>合作厂商一</div>
        <div>
          <router-link class="router_link" to="/Home/CJT">合作厂商二</router-link>
        </div>
      </div>
      <div class="partner_img">
        <div class="img">
          <img src="../assets/images/upr/1.png">
        </div>
        <div class="img">
          <img src="../assets/images/upr/2.png">
        </div>
        <div class="img">
          <img src="../assets/images/upr/3.png">
        </div>
      </div>
      <div class="section">
        <div>
          <div class="title">简介
            <div></div>
          </div>
          <div class="intro">
            某科技有限公司成立于2016年，注册资金800万元，使用面积2000平米。追求客户至上、持续改善、追求卓越、永续经营的品质方针。该公司于2016年建立完整的品质管理系统。2016年11月已通过TS16949：2009国际认证审核。主要成熟产品包括护套、保险丝盒、护线壳&扎带。
          </div>
        </div>
        <div class="philosophy">
          <div class="title">公司理念
            <div></div>
          </div>
          <div>
            <ul>
              <li>
                <div class="c_icon">
                  <img src="../assets/images/icon1.png">
                </div>
                <div>客户至上</div>
              </li>
              <li>
                <div class="sline"></div>
              </li>
              <li>
                <div class="c_icon">
                  <img src="../assets/images/icon3.png">
                </div>
                <div>持续改善</div>
              </li>
              <li>
                <div class="sline"></div>
              </li>
              <li>
                <div class="c_icon">
                  <img src="../assets/images/icon4.png">
                </div>
                <div>追求卓越</div>
              </li>
              <li>
                <div class="sline"></div>
              </li>
              <li>
                <div class="c_icon">
                  <img src="../assets/images/icon2.png">
                </div>
                <div>永续经营</div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {

    }
  }
}
</script>

<style scoped>
/* 二级导航栏 */
.header_nav>div:first-child {
  background:rgba(0,0,0,1);
  color: #fff;
}
/* 公司理念 */
.philosophy {
  margin-bottom: 60px;
  padding: 0 61px;
}
.philosophy ul {
  display: flex;
  justify-content: space-between;
}
.philosophy>ul>li {
  display: flex;
}
.c_icon+div {
  color: #707070;
}
.c_icon {
  width: 60px;
  height: 60px;
  margin-bottom: 37px;
}
.c_icon>img {
  width: 100%;
  height: 100%;
}
.sline {
  width: 1px;
  height: 65px;
  background-color: #c1c1c1;
}
</style>